import React from "react";

export type DropdownInputContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setValue: (value: string | undefined) => void;
  itemClass: string;
  focusClass: string;
};

export const DropdownInputContext = React.createContext<
  DropdownInputContextValue
>({
  isOpen: false,
  open: () => undefined,
  close: () => undefined,
  toggle: () => undefined,
  setValue: () => undefined,
  itemClass: "",
  focusClass: "",
});
